import layersMap from './../layer';
import realestateLayers from './layer';
import WKT from 'ol/format/WKT';
import proj from 'ol/proj';
import {transformExtent,transform} from 'ol/proj';
import config from './../config';

const $ = window.$;

var Sqrl = require('squirrelly')
const bigSmallMapBreakpoint = 768;
var compiledRealestateTemplate = Sqrl.Compile(document.getElementById("realestatetemplate").innerHTML)

var SimplePromise = function () {
    this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
    });
}

function fetchRealestateInfoByID(id, point) {
    //layersMap.selectLayer.getSource().clear();
    let wktReader = new WKT({
        dataProjection: "EPSG:25832",
        featureProjection: "EPSG:3857"
    });
    let selectedPoint = wktReader.readGeometry(point);
    var feature = realestateLayers.realestateLayer.getSource().forEachFeature(feature => {
        let env = wktReader.readGeometry(feature.get("env"))
        if (env.intersectsCoordinate(selectedPoint.getCoordinates())) {
            return feature;
        }
    });

    //the cluster feature is in map extent
    if (feature) {
        let selectStyle = realestateLayers.realestateLayer.get("selectStyle");
        if (realestateLayers.selection.feature) {
            realestateLayers.selection.feature.setStyle(null)
        }
        realestateLayers.selection.feature = feature;
        feature.setStyle(selectStyle);


        var params = "envelopeWKT=" + encodeURIComponent(feature.get("env")) + "&selected=" + id
        handleRealestateFetchResponse(fetch(contextPath + '/rest/realestate/info/' + lang + '?' + params))
    } else {
        handleRealestateFetchResponse(fetch(contextPath + '/rest/realestate/info/' + lang + '/' + id)).then(res => {
            if (realestateLayers.selection.feature) {
                realestateLayers.selection.feature.setStyle(null)
            }
            realestateLayers.selection.feature = null;


        })
    }


}

function fetchRealestateInfo(envelopeWKT, selectedID) {
    layersMap.selectLayer.getSource().clear();
    var params = "envelopeWKT=" + encodeURIComponent(envelopeWKT) + "&selected=" + selectedID

    var formElements = $("form").serializeArray();
    var query = "";
    formElements.forEach(function (elem) {

        if (elem.name.startsWith("j_id") || elem.name === "currentPage" || elem.name === "city_select" || elem.name === "javax.faces.ViewState") {
            return;
        }

        query += "&" + elem.name + "=" + (elem.value === "on" ? true : elem.value);
    })

    handleRealestateFetchResponse(fetch(contextPath + '/rest/realestate/info/' + lang + '?' + params + query))
}

function handleRealestateFetchResponse(fetchPromise) {


    let simplePromise = new SimplePromise();

    fetchPromise.then(function (response) {
        if (response.status === 200) {
            return response.json();
        } else {
            $(".selectinfo").hide()
            $(".map-inner .selectinfo").attr("data-status", "closed");
            $(".map-inner .selectinfo").attr("data-id", "");
        }
    })
        .then(function (realestateInfoJson) {
            if (realestateInfoJson) {

                realestateLayers.selection.id = realestateInfoJson.id;
                realestateLayers.selection.point = realestateInfoJson.selectedPoint;

                //
                var defaultProperties = {
                    marketingtype: { value: "" },
                    info_geomnotexact: { value: "" },
                    obj_address: { value: "" },
                    objecttype: { value: "" },
                    location: { value: "" },
                    name: { value: "" }
                };

                realestateInfoJson.properties = Object.assign({}, defaultProperties, realestateInfoJson.properties);

                realestateInfoJson.extent = [realestateInfoJson.extent.minX,
                realestateInfoJson.extent.minY,
                realestateInfoJson.extent.maxX,
                realestateInfoJson.extent.maxY].join();
                realestateInfoJson.display_paginator = realestateInfoJson.ids.length > 1 ? "d-flex" : "d-none"
                realestateInfoJson.count = realestateInfoJson.ids.length;
                realestateInfoJson.display_prev = realestateInfoJson.selectedIndex === 0 ? "d-none" : "";
                realestateInfoJson.display_next = (realestateInfoJson.ids.length - 1 === realestateInfoJson.selectedIndex) ? "d-none" : "";
                realestateInfoJson.prev_id = realestateInfoJson.ids[Math.max(realestateInfoJson.selectedIndex - 1, 0)];
                realestateInfoJson.next_id = realestateInfoJson.ids[Math.min(realestateInfoJson.selectedIndex + 1, realestateInfoJson.ids.length - 1)];



                var html = compiledRealestateTemplate(realestateInfoJson, Sqrl)

                $(".selectinfo .info_realestate").html(html)

                if ($(window).width() < bigSmallMapBreakpoint) {
                    var popupStatus = $(".map-inner .selectinfo").attr("data-status") || "open";
                    var dataID = $(".map-inner .selectinfo").attr("data-id");
                    if (popupStatus !== "folded" || dataID != realestateInfoJson.id) {
                        $(".map-inner .selectinfo").css("left", "");
                        $("#togglemap .selectinfo .card-body").show()
                        $("#togglemap .selectinfo").show();
                        $(".map-inner .selectinfo").attr("data-status", "open");
                        $(".map-inner .selectinfo").attr("data-id", realestateInfoJson.id + "");
                        $('#map-tab').tab('show')
                    }

                } else {
                    $("#map .selectinfo").show();
                }

                simplePromise.resolve({
                    id: realestateInfoJson.id,
                    selectedPoint: realestateInfoJson.selectedPoint
                })
            } else {
                $(".selectinfo").hide();
                $(".map-inner .selectinfo").attr("data-status", "closed");
                $(".map-inner .selectinfo").attr("data-id", "");
                realestateLayers.selection.feature = null;
                realestateLayers.selection.id = null;
                realestateLayers.selection.point = null;
            }
        });

    return simplePromise.promise;

}




function updateRealestate2(map, fit) {
    var extent = map.getView().calculateExtent(map.getSize())
    extent = transformExtent(extent, "EPSG:3857", "EPSG:25832")
    if (fit) {
        extent = config.getCustomMapOptions().extent;
    }

    var outputEnv = extent.join(",");
    var outputWidth = map.getSize()[0];
    var query = "?profil=35&cellSize=80&outputEnv=" + outputEnv + "&outputWidth=" + outputWidth + "&dummy=dummy";
    query = query + realestateLayers.query;
    fetch(contextPath + "/rest/cluster/realestate" + query)
        .then(function (response) {
            return response.json();
        }).then((data) => {
            var wktReader = new WKT({
                dataProjection: "EPSG:25832",
                featureProjection: "EPSG:3857"
            });

            var features = data.root.map(entry => {
                var f = wktReader.readFeature(entry.point, {
                    dataProjection: "EPSG:25832",
                    featureProjection: "EPSG:3857"
                })
                f.set("category", entry.category)
                f.set("exact", entry.exact)
                f.set("zipcode", entry.zipcode)
                f.set("count", entry.count)
                f.set("zipcode", entry.zipcode)
                f.set("env", entry.env)

                if (realestateLayers.selection.point) {
                    let selectedPoint = wktReader.readGeometry(realestateLayers.selection.point);
                    let featureEnv = wktReader.readGeometry(entry.env);
                    if (featureEnv.intersectsCoordinate(selectedPoint.getCoordinates())) {
                        f.setStyle(realestateLayers.realestateLayer.get("selectStyle"))
                        realestateLayers.selection.feature = f;
                        fetchRealestateInfo(entry.env, realestateLayers.selection.id);
                    }
                }
                return f;
            })

            realestateLayers.realestateLayer.getSource().clear();
            realestateLayers.realestateLayer.getSource().addFeatures(features);
            if (fit) {
                map.getView().fit(realestateLayers.realestateLayer.getSource().getExtent());
            }

        }).catch(function (error) { console.log(error) });


}






export default {
    updateRealestate2: updateRealestate2,
    fetchRealestateInfoByID: fetchRealestateInfoByID,
    fetchRealestateInfo: fetchRealestateInfo
}

